import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	showMoreRepliesText: {
		id: 'issue-view-activity-comment.comment-replies.show-more-replies',
		defaultMessage: 'Show more replies',
		description: 'Message to show more replies button label',
	},
});
